import { MutableRefObject, useEffect, useState } from "react";

const useEffectInEvent = (event: "resize" | "scroll", set: () => void) => {
  useEffect(() => {
    set();
    window.addEventListener(event, set);
    return () => window.removeEventListener(event, set);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useRect = <T extends Element>(
  ref: MutableRefObject<T | null | undefined>
): DOMRect | undefined => {
  const [rect, setRect] = useState<DOMRect | undefined>(ref?.current?.getBoundingClientRect());
  const set = () => setRect(ref.current?.getBoundingClientRect());
  useEffectInEvent("resize", set);

  useEffect(() => {
    if (ref) {
      setRect(ref.current?.getBoundingClientRect());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ref.current]);
  return rect;
};
